import {
  addToaster,
  attachCaseById,
  CreateChildInstanceType,
  createWorkflowInstance,
  DataTypeStore,
  fetchCaseIdUsingWorkFlowAndDefinitionId,
  fetchDuplicateRecordsAPI,
  FILTER_KEYS,
  getAllLayoutApi,
  getAllWorkflowListUsingServiceId,
  getEntityDataByEntityFilter,
  getEntityDataByEntityNameApiForFilter,
  GetEntityDataByNameIdFilter,
  getLayoutByEntityIdAndTypeApi,
  getLayoutByName,
  hideLoader,
  LayoutResponseType,
  showLoader,
  transformToDuplicateApiPayload,
  triggerInteractionStatusEvent,
  updateRequestorConfigReducer,
  WorkflowDefinitionsListType,
  WorkflowInstanceType,
  WorkflowItem,
  WorkflowProcessType,
} from '@app-store'
import { useContext, useEffect, useRef, useState } from 'react'
import {
  ListingTableProps,
  ListingTableRow,
} from '../../types/listingTable.types'
import {
  ACTION_ICONS_NAMESPACE,
  ConfirmDialog,
  CustomButton,
  Loader,
  Modal,
  MODE_CONSTANTS,
  PositionPropsState,
  SvgChevronUp,
  SvgEntity,
  SvgExpandModal,
  SvgLeftArrow,
  SvgMinimiseModal,
  SvgReload,
  TabInterface,
  TableActionType,
  Tooltip,
} from '@ui-kit'
import { ListingTable } from '../../components/listing-table/ListingTable'
import {
  ADVANCE_SEARCH_ENTITY_NAMES_MAPPING,
  BUTTONS,
  CUSTOM_SEPERATOR,
  ENTITY_FIELDS,
  ENTITY_NAME,
  LAYOUT_TYPE_NAMESPACE,
  NAMESPACES,
  REPORTS,
} from '../../utils/constants'
import {
  RootState,
  useAppDispatch,
  useAppSelector,
} from '../../utils/agent.store'
import { SelectWorkFlowDropDownPropsType } from '../../types/workflow.types'
import { cloneDeep, isEmpty, noop, union, uniqueId } from 'lodash'
import { useParams } from 'react-router-dom'
import { createPortal } from 'react-dom'
import RequesterSearchForm, { AdvancedSearchInfo } from './RequestorSearchForm'
import { CallInteractionContext } from './CallInteactionContext'
import { ShortcutKeys } from '../../constants/form.constants'
import { v4 as uuid } from 'uuid'
import {
  logErrorMessage,
  reverseMappingOfRequestorName,
} from '../../utils/helperFunctions'
import { getCurrentLocalDate } from '../../utils/date.utils'
import {
  APPLICATION_PREFERENCES_STRINGS,
  CALL_INTERACTIONS,
  DUPLICATION,
} from '../../utils/strings'
import { TOASTER_NAMESPACE } from '../../constants/addEditPage.strings'
import { FieldValues } from 'react-hook-form'
import { addEntityData, getEntityData } from '../../apis/entityData.api'
import FormRenderer from '../../components/FormRenderer'
import { EntityLayout, LayoutData } from '../../types/layout.types'
import { ListingTableColumn } from '../../utils/types'
import { DuplicationScore } from '../../components/DuplicationScore'
import { Group } from '../../types/types'
import { updateInteractionStatus } from '../../utils/aws-connect.utils'
import { AxiosError } from 'axios'
import {
  removeAuditFieldsAndFormatValues,
  validatePhoneNumberAndAddress,
} from '../../utils/form.utils'

const SearchNoDataScreen = (entityName: string) => {
  return (
    <div className="flex flex-col items-center justify-center border border-accent-100 rounded mt-2 p-6">
      <div className="flex flex-col items-center gap-3">
        <SvgEntity className="w-20 h-20 text-accent-400" />
        <p className="font-primary font-light text-xs text-center text-accent-800">
          No {entityName} record found
        </p>
      </div>
    </div>
  )
}

const SearchLayout = (props: {
  isLookupSearch?: boolean
  currentInteractionTab?: TabInterface
  singleEntity?: boolean
  entity_id: string
  entity_name: string
  selectedProgramId?: string
  isLookup?: boolean
  selectedProductId?: string
  selectedChannelId?: string
  isLeftPanel?: boolean
  organizationType?: { label: string; value: string }
  communicationKey?: string
  setBackToFirstPage?: React.Dispatch<React.SetStateAction<boolean>>
  backToFirstPage?: boolean
  setViewEntityRecord?: React.Dispatch<
    React.SetStateAction<DataTypeStore | undefined>
  >
  viewEntityRecord?: DataTypeStore
  handleCreateWorkflowInstance?: (
    process: WorkflowProcessType,
    instance: WorkflowInstanceType
  ) => void
  tabIndex?: number
  currStep?: number
  setCurrStep?: React.Dispatch<React.SetStateAction<number>>
  setRequestorId?: (requestorId: number) => void
  receivedDate?: string
  recordFieldsEntityDataPayload?: {
    payload: GetEntityDataByNameIdFilter
    fromSearch?: boolean
  }
  setRecordFieldsEntityDataPayload?: React.Dispatch<
    React.SetStateAction<
      | {
          payload: GetEntityDataByNameIdFilter
          fromSearch?: boolean
        }
      | undefined
    >
  >
  setRecordFieldsInfo?: React.Dispatch<
    React.SetStateAction<{
      page: number
      size: number
    } | null>
  >
  recordFieldsInfo?: {
    page: number
    size: number
  } | null
  advancedFiltersData?: AdvancedSearchInfo
  setAdvancedFiltersData?: React.Dispatch<
    React.SetStateAction<AdvancedSearchInfo | undefined>
  >
  setEditEntityRecord?: React.Dispatch<
    React.SetStateAction<boolean | undefined>
  >
  setAddEntityRecord?: React.Dispatch<React.SetStateAction<boolean | undefined>>
  setIsViewClicked?: React.Dispatch<React.SetStateAction<boolean>>
  triggerSearch?: boolean
  isIncomingCall?: boolean
  fromTask?: boolean
  isOriginInteraction?: boolean
}) => {
  const {
    handleModal,
    handleIsEditMode,
    isEditMode,
    tabs,
    setTabs,
    workflowList,
  } = useContext(CallInteractionContext)
  const [addLayout, setAddLayout] = useState<LayoutResponseType | undefined>()
  const [, setFormData] = useState<FieldValues>()
  const [fetchKey, setFetchKey] = useState<number>(0)
  const [recordLength, setRecordLength] = useState<number>(0)
  const [listingLayout, setListingLayout] = useState<LayoutResponseType>()
  const [duplicateListingLayout, setDuplicateListingLayout] =
    useState<LayoutResponseType>()
  const [isDuplicateModalOpen, setIsDuplicateModalOpen] =
    useState<boolean>(false)
  const [viewDuplicateRecord, setViewDuplicateRecord] = useState<boolean>(false)
  const [addedRecord, setAddedRecord] = useState<FieldValues | null>(null)
  const [selectedRow, setSelectedRow] = useState<ListingTableRow | null>(null)
  const [totalRecords, setTotalRecords] = useState<number>(0)
  const [refetchKey, setRefetchKey] = useState<number>(0)
  const [viewLayout, setViewLayout] = useState<LayoutResponseType>()
  const [viewRecordData, setViewRecordData] = useState<FieldValues>()
  const [isExpandModalOpen, setIsExpandModalOpen] = useState<boolean>(false)
  const [isLinkModalOpen, setIsLinkModalOpen] = useState<boolean>(false)
  const allLayouts = useRef<LayoutResponseType[]>([])
  const [attachCaseId, setAttachCaseId] = useState<number>()
  const [openAddModal, setOpenAddModal] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [clearAddModalData, setClearAddModalData] = useState(false)
  const [entityDataPayload, setEntityDataPayload] = useState<{
    payload: GetEntityDataByNameIdFilter
    fromSearch?: boolean
  }>()

  const [workflowListUsingService, setWorkflowListUsingService] = useState<
    WorkflowDefinitionsListType[]
  >([])
  const relationshipTree = useAppSelector(
    (state) => state?.workflowData?.relationshipTree
  )
  const intakeCommunicationMap = useAppSelector(
    (state) => state?.workflowData?.intakeCommunicationMap
  )
  const authUser = useAppSelector((state) => state.authUser)
  const entitiesByName = useAppSelector(
    (state: RootState) => state.entity.entitiesByName
  )

  const dispatch = useAppDispatch()
  const isCallInteractionActive =
    props?.isIncomingCall &&
    props?.isOriginInteraction &&
    props.entity_name !== ENTITY_NAME.FACILITY
  const { communicationId } = useParams()
  const getEntityId = (
    rightRow: DataTypeStore,
    entity_name: string,
    leftRow: DataTypeStore,
    targetEntityType: 'Provider' | 'Patient'
  ) => {
    if (entity_name === targetEntityType) {
      return {
        id:
          !isCallInteractionActive &&
          targetEntityType === NAMESPACES.PATIENT_KEY
            ? Number(rightRow?.record_id ?? rightRow?.id)
            : Number(rightRow.id),
        _state: 'ADDED',
      }
    }
    if (leftRow?.entity_type === targetEntityType) {
      return {
        id:
          !isCallInteractionActive &&
          targetEntityType === NAMESPACES.PATIENT_KEY
            ? leftRow?.record_id ?? leftRow?.id
            : leftRow.id,
        _state: 'ADDED',
      }
    }
    return undefined
  }
  const getRequestorId = (leftRow: DataTypeStore) =>
    leftRow.requestor_id
      ? {
          id: Number(leftRow.requestor_id),
          _state: 'ADDED',
        }
      : undefined

  const getParentCaseId = (rightRow: DataTypeStore, entity_name: string) => {
    return entity_name === 'Case'
      ? { parent_case_id: Number(rightRow?.id) }
      : {}
  }

  const createWorkflowInstanceForSelected = async (
    selectedWorkflow: WorkflowDefinitionsListType,
    leftRow: DataTypeStore,
    rightRow: DataTypeStore
  ) => {
    if (!intakeCommunicationMap) return
    let isNewTabPresent = false
    for (const tab of tabs ?? []) {
      if (tab.label.includes('New Case')) {
        isNewTabPresent = true
        break
      }
    }
    if (isNewTabPresent) {
      try {
        await new Promise((resolve, reject) => {
          handleModal &&
            handleModal({
              message: NAMESPACES.UNSAVED_CHANGES_MESSAGE,
              state: true,
              onYesClick: () => {
                resolve(true)
              },
              onCancelClick: () => {
                reject(new Error('false'))
              },
            })
        })
        setTabs &&
          setTabs((prev) => {
            const newTabs = [...prev]
            const newEditMode = { ...isEditMode }
            newTabs.forEach((tab, index) => {
              if (tab.label.includes('New Case')) {
                tab.label = tab.label.replace('New Case - ', '')
                newEditMode[index] = false
              }
            })
            handleIsEditMode && handleIsEditMode(newEditMode)
            return newTabs
          })
      } catch (err) {
        console.error(err)
        return
      }
    }
    const communicationEntity = relationshipTree?.filter(
      (item) =>
        item?.entity_id?.toString() ===
        (selectedWorkflow?.global_variables?.entities?.communication
          ?.entity_id ?? '59')
    )
    const programEntity = relationshipTree?.find(
      (item) =>
        item?.entity_id?.toString() ===
        (selectedWorkflow?.global_variables?.entities?.program?.entity_id ??
          '94')
    )
    const productEntity = relationshipTree?.find(
      (item) =>
        item?.entity_id?.toString() ===
        (selectedWorkflow?.global_variables?.entities?.product?.entity_id ??
          '78')
    )
    const patientEntity = relationshipTree?.find(
      (item) =>
        item?.entity_id?.toString() ===
        (selectedWorkflow?.global_variables?.entities?.patient?.entity_id ??
          '18')
    )
    const providerEntity = relationshipTree?.find(
      (item) =>
        item?.entity_id?.toString() ===
        (selectedWorkflow?.global_variables?.entities?.providers?.entity_id ??
          '4')
    )
    const requestorEntity = relationshipTree?.find(
      (item) =>
        item?.entity_id?.toString() ===
        (selectedWorkflow?.global_variables?.entities?.requestor?.entity_id ??
          '1161')
    )
    const userEntity = relationshipTree?.find(
      (item) =>
        item?.entity_id?.toString() ===
        (selectedWorkflow?.global_variables?.entities?.users?.entity_id ?? '74')
    )
    const caseSummaryEntity = relationshipTree?.find(
      (item) =>
        item?.entity_id?.toString() ===
        (selectedWorkflow?.global_variables?.entities?.case_summary
          ?.entity_id ?? '1311')
    )
    try {
      dispatch(showLoader())
      const embedded =
        Object?.keys(
          selectedWorkflow?.global_variables?.inherited_variables ?? {}
        ) || []
      const faxReceivedDate =
        selectedWorkflow?.global_variables?.config_fields?.case
          ?.fax_received_date ?? ''
      const payload: {
        flow_meta_data: {
          process_definition_id: string
          communication_id: string | undefined
        }
        meta_data: {
          entity_name: string
          embedded: (string | undefined)[]
        }
        data: {
          [key: string]:
            | string
            | undefined
            | { id: string | undefined; _state: string }[]
            | number
            | boolean
        }
      } = {
        flow_meta_data: {
          process_definition_id: selectedWorkflow?.id ?? '',
          communication_id: communicationId,
        },
        meta_data: {
          entity_name: selectedWorkflow?.global_variables?.entity_name ?? '',
          embedded: [
            ...embedded,
            // communicationEntity?.field_name ?? '',
            ENTITY_FIELDS?.case?.communication ?? '',
            programEntity?.field_name ?? '',
            providerEntity?.field_name ?? '',
            patientEntity?.field_name ?? '',
            productEntity?.field_name ?? '',
            requestorEntity?.field_name ?? '',
            userEntity?.field_name ?? '',
            caseSummaryEntity?.field_name ?? '',
            selectedWorkflow?.global_variables?.associated_variables?.document
              ?.parent_entity,
            'intake_channel_id',
            'parent_case_id',
            'source_id',
            'case_start_date',
            ...(faxReceivedDate ? [faxReceivedDate] : []),
          ],
        },
        data: {
          ...(selectedWorkflow?.global_variables?.inherited_variables || {}),
          [userEntity?.field_name ?? '']: {
            id: Number(authUser?.user?.id),
            _state: 'ADDED',
          },
          [programEntity?.field_name ?? '']: {
            id: Number(props.selectedProgramId),
            _state: 'ADDED',
          },
          [productEntity?.field_name ?? '']: {
            id: Number(props.selectedProductId),
            _state: 'ADDED',
          },
          [providerEntity?.field_name ?? '']: getEntityId(
            rightRow,
            props.entity_name,
            leftRow,
            'Provider'
          ),
          [patientEntity?.field_name ?? '']: getEntityId(
            rightRow,
            props.entity_name,
            leftRow,
            'Patient'
          ),
          [requestorEntity?.field_name ?? '']: getRequestorId(leftRow),
          [caseSummaryEntity?.field_name ?? '']: {
            record_status: 'ACTIVE',
            _state: 'CHANGED',
          },
          ...getParentCaseId(rightRow, props?.entity_name),
          intake_channel_id:
            intakeCommunicationMap[props.selectedChannelId ?? '0'],
          source_id: props.communicationKey ?? '',
          case_start_date: new Date(getCurrentLocalDate()).toISOString(),
          ...(faxReceivedDate ? { [faxReceivedDate]: props.receivedDate } : {}),
        },
      }

      if (
        selectedWorkflow?.definition &&
        selectedWorkflow?.service_id &&
        props.entity_name === ENTITY_NAME.CASE
      ) {
        const reviewer = `${authUser?.user?.first_name} ${authUser?.user?.last_name}`
        const fetchCasePayload: CreateChildInstanceType = {
          process_request: {
            flow_meta_data: {
              process_definition_id: selectedWorkflow.id ?? '',
              communication_id: communicationId ?? '',
            },
            meta_data: {
              entity_name:
                selectedWorkflow?.global_variables?.entity_name ?? '',
              embedded: [
                ...embedded,
                productEntity?.field_name ?? '',
                userEntity?.field_name ?? '',
                'intake_channel_id',
                ...(faxReceivedDate ? [faxReceivedDate] : []),
                requestorEntity?.field_name ?? '',
              ],
            },
            data: {
              source_id: props.communicationKey ?? '',
              products: {
                id: Number(props.selectedProductId),
                _state: 'ADDED',
              },
              intake_channel_id:
                intakeCommunicationMap[props.selectedChannelId ?? '0'],
              request_received_at: props.receivedDate ?? '',
              users: {
                id: Number(authUser?.user?.id),
                _state: 'ADDED',
              },
              requestor: getRequestorId(leftRow),
            },
          },
          procedure_param: {
            show_intake_form: true,
            source_id: props.communicationKey ?? '',
            case_id: rightRow?.id as number,
          },
        }
        if (communicationEntity?.length) {
          communicationEntity.forEach((item) => {
            if (item?.field_name) {
              fetchCasePayload.process_request.meta_data.embedded.push(
                item?.field_name
              )
              fetchCasePayload.process_request.data[item.field_name] = [
                {
                  id: communicationId,
                  _state: 'ADDED',
                },
              ]
            }
          })
        }
        const response = await fetchCaseIdUsingWorkFlowAndDefinitionId(
          fetchCasePayload,
          selectedWorkflow.id ?? '',
          isCallInteractionActive
            ? (rightRow['process_instance_case.prc_def_id'] as number)
            : (rightRow['prc_def_id'] as number),
          reviewer ?? '',
          communicationId ?? ''
        )

        if (response?.data && props.handleCreateWorkflowInstance) {
          props.handleCreateWorkflowInstance(
            response?.data?.process,
            response?.data?.workflow_instance
          )
        }
      } else {
        if (communicationEntity?.length) {
          communicationEntity.forEach((item) => {
            if (item?.field_name) {
              payload.meta_data.embedded.push(item?.field_name)
              payload.data[item.field_name] = [
                {
                  id: communicationId,
                  _state: 'ADDED',
                },
              ]
            }
          })
        }
        const response = await createWorkflowInstance({
          InstanceId: selectedWorkflow?.id ?? '',
          data: payload,
        })
        if (response?.data && props.handleCreateWorkflowInstance) {
          props.handleCreateWorkflowInstance(
            response?.data?.process,
            response?.data?.workflow_instance
          )
        }
      }
    } catch (err) {
      const status = (err as AxiosError).response?.status
      const data = (err as AxiosError)?.response?.data
      const message = (data as unknown as { message: string })?.message
      if (status === 409) {
        dispatch(
          addToaster({
            id: uniqueId(),
            message,
            type: 'error',
          })
        )
      }
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }
  const fetchWorkFlowListUsingServiceId = async (
    definitionId: number,
    programId: number
  ) => {
    try {
      setWorkflowListUsingService([])
      dispatch(showLoader())
      const response = await getAllWorkflowListUsingServiceId(
        definitionId,
        programId
      )
      if (response?.data) {
        if (response?.data) {
          response.data = response.data.filter((item: WorkflowItem) => {
            return !item.name.includes(FILTER_KEYS.DO_NOT_USE)
          })
        }
        setWorkflowListUsingService(response?.data ?? [])
      }
    } catch (err) {
      logErrorMessage('workflow instance using definition id', err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const requestorPayload = (row: DataTypeStore) => ({
    entity_name: 'requestor_view',
    select: ['name', 'record_id', 'record_key', 'entity_type'],
    page: 0,
    size: 1,
    filters: [
      {
        criteria: [
          {
            field_name: 'record_key',
            operation: 'LIKE',
            values: [
              ((isCallInteractionActive
                ? row?.patient_key
                : row?.['Patient ID']) ||
                (isCallInteractionActive
                  ? row?.provider_key
                  : row?.['Provider ID']) ||
                (isCallInteractionActive ? row?.case_key : row?.case_id) ||
                row?.['Facility ID'] ||
                row?.contact_key ||
                row?.organization_key ||
                '') as string,
            ],
          },
        ],
      },
    ],
  })

  const fetchAndSetRequestorData = async (row: DataTypeStore) => {
    dispatch(showLoader())
    const response = await getEntityDataByEntityNameApiForFilter({
      payload: requestorPayload(row),
    })
    const updatedResponse = reverseMappingOfRequestorName(response.data.content)
    props.setViewEntityRecord?.({
      ...row,
      requestor_id: updatedResponse?.[0]?.id,
      entity_type: updatedResponse?.[0]?.entity_type,
      requestor_callback_data: response?.data?.content?.[0],
    })
    if (props.setRequestorId) {
      props.setRequestorId(updatedResponse?.[0]?.id)
    }
    dispatch(hideLoader())
  }

  const getActions = (): ListingTableProps['extraActions'] => {
    if (props?.isLeftPanel) {
      return [
        {
          label: 'Select',
          key: 'select',
          type: 'component',
          renderActionComponent: (row) => {
            return (
              <CustomButton
                className="!h-[1.75rem]"
                onClick={(e) => {
                  setIsExpandModalOpen(false)
                  e?.stopPropagation()
                  e?.preventDefault()
                  dispatch(updateRequestorConfigReducer({ row }))
                  fetchAndSetRequestorData(row)
                  if (props?.setBackToFirstPage) {
                    props?.setBackToFirstPage(false)
                    props?.setCurrStep?.((prev) => prev + 1)
                  }
                }}
                type="button"
              >
                Select
              </CustomButton>
            )
          },
        },
        {
          label: NAMESPACES.EDIT,
          key: ACTION_ICONS_NAMESPACE.EDIT,
          onClick: async (row) => {
            setIsExpandModalOpen(false)
            await fetchAndSetRequestorData(row)
            props.setEditEntityRecord?.(true)
          },
        },
      ]
    }
    if (props?.isLookup) {
      return [
        {
          label: 'Select',
          key: 'select',
          type: 'component',
          renderActionComponent: (row) => {
            return (
              <CustomButton
                className="!h-[1.75rem]"
                onClick={(e) => {
                  e?.stopPropagation()
                  e?.preventDefault()
                  fetchAndSetRequestorData(row)
                  setIsExpandModalOpen(false)
                  if (props?.setBackToFirstPage) {
                    props?.setBackToFirstPage(false)
                    props?.setCurrStep?.((prev) => prev + 1)
                  }
                }}
                type="button"
              >
                Select
              </CustomButton>
            )
          },
        },
        {
          label: NAMESPACES.EDIT,
          key: ACTION_ICONS_NAMESPACE.EDIT,
          onClick: async (row) => {
            await fetchAndSetRequestorData(row)
            props.setEditEntityRecord?.(true)
            setIsExpandModalOpen(false)
          },
        },
        {
          label: NAMESPACES.VIEW,
          key: ACTION_ICONS_NAMESPACE.VIEW,
          onClick: async (row) => {
            setIsExpandModalOpen(false)
            if (props?.fromTask) await fetchAndSetRequestorData(row)
            else props.setViewEntityRecord?.(row)
            props.setIsViewClicked?.(true)
          },
        },
      ]
    }
    return [
      props.entity_name === ENTITY_NAME.CASE && {
        label: 'Link',
        key: 'link',
        showInPopUp: false,
        type: 'component',
        renderActionComponent: (row: DataTypeStore) => {
          return (
            <CustomButton
              className="!h-[1.75rem]"
              onClick={() => {
                setAttachCaseId(Number(row?.id))
                setIsLinkModalOpen(true)
              }}
            >
              <Tooltip content={CALL_INTERACTIONS.LINK_TOOLTIP}>
                {CALL_INTERACTIONS.LINK}
              </Tooltip>
            </CustomButton>
          )
        },
      },
      {
        label: REPORTS.CREATE_CASE,
        key: 'create_case',
        showInPopUp: false,
        type: 'component',
        renderActionComponent: (row: DataTypeStore) => {
          return (
            <SelectWorkFlowDropDown
              workflowList={
                props.entity_name === ENTITY_NAME.CASE
                  ? workflowListUsingService
                  : workflowList ?? []
              }
              updateSelectWorkflow={(
                selectedWorkflow: WorkflowDefinitionsListType
              ) => {
                createWorkflowInstanceForSelected(
                  selectedWorkflow,
                  props?.viewEntityRecord ?? {},
                  row
                )
              }}
              tabIndex={props?.tabIndex ?? 0}
              onDropDownClick={() => {
                if (props.entity_name === ENTITY_NAME.CASE) {
                  if (row['process_instance_case.prc_def_id'])
                    fetchWorkFlowListUsingServiceId(
                      Number(row['process_instance_case.prc_def_id']),
                      Number(row['programs.id'])
                    )
                  else if (row['prc_def_id'])
                    fetchWorkFlowListUsingServiceId(
                      Number(row['prc_def_id']),
                      Number(row['program_id'])
                    )
                  else
                    setWorkflowListUsingService(
                      workflowList ? [...workflowList] : []
                    )
                }
              }}
            />
          )
        },
      },
    ].filter(Boolean) as ListingTableProps['extraActions']
  }

  const getEntityViewName = (
    entityName: string,
    updatedPayload: GetEntityDataByNameIdFilter
  ): string => {
    switch (entityName) {
      case NAMESPACES.PATIENT_KEY:
        return ENTITY_NAME.PATIENT_ENROLLMENT_VIEW_KEY

      case NAMESPACES.PROVIDER_KEY:
        return ENTITY_NAME.PROVIDER_VIEW_KEY

      case ENTITY_NAME.CASE:
        return ENTITY_NAME.CASE_VIEW_KEY

      case ENTITY_NAME.FACILITY:
        return ENTITY_NAME.FACILITIES_VIEW_KEY

      default:
        return updatedPayload?.payload?.entity_name ?? ''
    }
  }

  const fetchTableDataCallback: ListingTableProps['dataFetchCallback'] = async (
    payload
  ) => {
    try {
      dispatch(showLoader())
      if (
        entityDataPayload?.payload ??
        props?.recordFieldsEntityDataPayload?.payload
      ) {
        const updatedPayload = cloneDeep(
          entityDataPayload?.payload ??
            props?.recordFieldsEntityDataPayload?.payload
        )
        if (updatedPayload?.payload) {
          updatedPayload.payload.related_entities = {
            ...updatedPayload.payload.related_entities,
            programs: {
              filters: [
                {
                  criteria: [
                    {
                      field_name: 'id',
                      operation: 'EQUALS',
                      values: [props.selectedProgramId ?? ''],
                    },
                  ],
                },
              ],
            },
            process_instance_case: {
              select: ['prc_def_id'],
              filters: [],
            },
          }
        }
        if (updatedPayload?.payload?.select) {
          if (isCallInteractionActive) {
            updatedPayload.payload.select.push('programs')
            updatedPayload.payload.select.push('process_instance_case')
          } else {
            updatedPayload.payload.select.push('program_id')
            updatedPayload.payload.select.push('prc_def_id')
          }
          updatedPayload.payload.select = union(
            payload?.select ?? [],
            updatedPayload.payload.select
          )
        }
        if (updatedPayload?.payload?.filters) {
          updatedPayload.payload.page = Number(
            payload?.page ?? props?.recordFieldsInfo?.page
          )
          props?.setRecordFieldsInfo?.((prev) => {
            return {
              ...prev,
              page: Number(payload?.page ?? props?.recordFieldsInfo?.page),
              size: Number(payload?.size ?? props?.recordFieldsInfo?.size),
            }
          })
          if (
            entityDataPayload?.fromSearch ??
            props?.recordFieldsEntityDataPayload?.fromSearch
          ) {
            updatedPayload.payload.page = 0
            if (
              entityDataPayload?.payload ??
              props?.recordFieldsEntityDataPayload?.payload
            ) {
              setEntityDataPayload({
                fromSearch: false,
                payload: (entityDataPayload?.payload ??
                  props?.recordFieldsEntityDataPayload
                    ?.payload) as GetEntityDataByNameIdFilter,
              })
              props?.setRecordFieldsEntityDataPayload?.({
                fromSearch: false,
                payload: (entityDataPayload?.payload ??
                  props?.recordFieldsEntityDataPayload
                    ?.payload) as GetEntityDataByNameIdFilter,
              })
            }
          }
          updatedPayload.payload.size = Number(
            payload?.size ?? props?.recordFieldsInfo?.size
          )
          // TODO: update size
        }

        payload?.filters?.forEach((item) =>
          updatedPayload?.payload?.filters?.push(item)
        )
        if (!isEmpty(payload?.related_entities) && updatedPayload) {
          updatedPayload.payload.related_entities = {
            ...payload.related_entities,
            ...updatedPayload?.payload?.related_entities,
          }
        }

        if (updatedPayload) {
          !isCallInteractionActive &&
            (updatedPayload.payload.entity_name = getEntityViewName(
              props.entity_name,
              updatedPayload
            ))
        }

        const response = await getEntityDataByEntityNameApiForFilter(
          updatedPayload as GetEntityDataByNameIdFilter
        )
        const newContent = reverseMappingOfRequestorName(response.data.content)
        const newData = {
          ...response.data,
          content: newContent,
        }
        setRecordLength(newData?.totalElements ?? '')
        if (
          newData?.totalElements === 1 &&
          props?.singleEntity &&
          isCallInteractionActive
        ) {
          setIsExpandModalOpen(false)
          fetchAndSetRequestorData(newData?.content?.[0] ?? {})
          if (props?.setBackToFirstPage) {
            props?.setBackToFirstPage(false)
            props?.setCurrStep?.((prev) => prev + 1)
          }
        }
        return { ...newData }
      }
    } catch (err) {
      console.log(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const onConfirmClick = async () => {
    const reviewer = `${authUser?.user?.first_name} ${authUser?.user?.last_name}`
    try {
      setIsLinkModalOpen(false)
      dispatch(showLoader())
      await attachCaseById({
        faxId: communicationId ?? '',
        caseId: attachCaseId ?? '',
        reason: NAMESPACES.NO_REASON,
        reviewer,
      })
      updateInteractionStatus(communicationId as string, 71)
      dispatch(triggerInteractionStatusEvent())
      dispatch(
        addToaster({
          id: uniqueId(),
          message: CALL_INTERACTIONS.LINK_TOASTER_SUCCESS_MESSAGE,
          type: 'success',
        })
      )
      setTimeout(() => {
        window.open(`/entity/32/workflow/review/${attachCaseId}`, '_blank')
      }, 1000)
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const toggleAddModal = () => {
    setOpenAddModal((prev) => !prev)
  }

  const handleAddModalData = async (values: FieldValues) => {
    try {
      setIsLoading(true)
      const response = await addEntityData(
        props?.entity_name,
        Number(props?.entity_id),
        addLayout?.id ?? 0,
        values,
        []
      )
      setFormData({
        record_id: response.data.id,
      })
      setFetchKey((prev) => prev + 1)
      dispatch(
        addToaster({
          message: TOASTER_NAMESPACE.ADD_SUCCESS,
          type: 'success',
          id: uuid(),
        })
      )
      setOpenAddModal(false)
    } catch (err) {
      dispatch(
        addToaster({
          message: TOASTER_NAMESPACE.FAILED_TO_ADD_RECORD,
          type: 'error',
          id: uuid(),
        })
      )
      console.error(err)
    } finally {
      setIsLoading(false)
    }
  }

  const fetchViewRecordData = async (layoutId: number, id: number) => {
    dispatch(showLoader())
    try {
      const res = await getEntityData(
        String(addLayout?.entity_name),
        Number(props?.entity_id),
        layoutId,
        id
      )
      if (res?.data) {
        setViewRecordData(res?.data)
      }
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const fetchViewLayout = async () => {
    dispatch(showLoader())
    try {
      const res = await getLayoutByEntityIdAndTypeApi({
        entityId: String(props?.entity_id),
        type: LAYOUT_TYPE_NAMESPACE?.OVERVIEW_TYPE,
        isDefault: true,
      })
      if (res?.data) {
        setViewLayout(res?.data?.[0])
        return res?.data?.[0]?.id
      }
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const extraAction: (TableActionType<DataTypeStore> & {
    onClick?: (row: ListingTableRow, rowIndex: number) => void
  })[] = [
    {
      label: NAMESPACES.VIEW,
      key: ACTION_ICONS_NAMESPACE.VIEW,
      onClick: async (row) => {
        const layoutId = await fetchViewLayout()
        setSelectedRow(row)
        setViewDuplicateRecord(true)
        fetchViewRecordData(layoutId, row?.id)
      },
    },
  ]

  const extraColumn: ListingTableColumn[] = [
    {
      header: '',
      accessor: DUPLICATION.SELECT_ACCESSOR,
      type: DUPLICATION.RADIO_TYPE,
      onClick(_KeyName, row, _rowIndex) {
        setSelectedRow(row)
        setRefetchKey((prev) => prev + 1)
      },
    },
    {
      header: APPLICATION_PREFERENCES_STRINGS.MATCH_SCORE,
      accessor: DUPLICATION.SCORE_ACCESSOR,
      type: DUPLICATION.COMPONENT_TYPE,
      renderComponent: (row) => {
        return (
          <div className="flex items-center gap-1">
            <span>{String(row?.score ?? '')}</span>
            <DuplicationScore
              groups={row?.matchDetails as unknown as Group[]}
            />
          </div>
        )
      },
    },
  ]

  const closeAndMoveToAdvancedSearch = () => {
    setAddedRecord(null)
    setIsDuplicateModalOpen(false)
    setViewDuplicateRecord(false)
    setOpenAddModal(false)
    props?.setAddEntityRecord?.(false)
    setFetchKey((prev) => prev + 1)
  }

  const createNewRecord = async (values?: FieldValues) => {
    dispatch(showLoader())
    try {
      const res = await addEntityData(
        addLayout?.entity_name ?? '',
        Number(props?.entity_id),
        Number(addLayout?.id),
        addedRecord ?? values ?? {}
      )
      if (res?.data) {
        addToaster({
          id: uniqueId(),
          message: TOASTER_NAMESPACE?.ADD_SUCCESS,
          type: 'success',
        })
        closeAndMoveToAdvancedSearch()
      }
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const fetchTableDataCallback2 = async (
    values: FieldValues,
    listingLayoutId: string | number,
    payload?: getEntityDataByEntityFilter['payload'] & { layout_id: number }
  ) => {
    if (listingLayoutId) {
      const duplicateApiPayload = transformToDuplicateApiPayload(
        values,
        props.entity_id.toString() ?? '',
        listingLayoutId.toString(),
        addLayout
      )
      const res = await fetchDuplicateRecordsAPI(
        Number(props.entity_id) ?? 0,
        duplicateApiPayload,
        payload?.page as number,
        payload?.size as number
      )
      const addSelectedFlag = (data: ListingTableRow[]) => {
        return data.map((row) => ({
          ...row,
          select: row?.id === selectedRow?.id ? true : false,
        }))
      }
      res.data.content = addSelectedFlag(res?.data?.content)
      setTotalRecords(res?.data?.totalElements ?? 0)
      if (res?.data?.content.length !== 0) {
        setAddedRecord(values)
        setIsDuplicateModalOpen(true)
      } else {
        createNewRecord(values)
      }
      return res?.data
    }
  }

  const fetchListingLayout = async () => {
    try {
      const res = await getLayoutByEntityIdAndTypeApi({
        entityId: props?.entity_id.toString() ?? '',
        type: LAYOUT_TYPE_NAMESPACE?.LAYOUT_LISTING,
        isDefault: true,
      })
      if (res?.data) {
        setDuplicateListingLayout(res.data?.[0])
        return res.data?.[0]
      }
    } catch (err) {
      console.log(err)
    }
  }

  const handleFormSubmit = async (
    finalvalues: FieldValues,
    _embedded: string[],
    originalFormData: FieldValues | undefined
  ) => {
    dispatch(showLoader())
    try {
      const data = removeAuditFieldsAndFormatValues(
        { ...finalvalues, ...originalFormData },
        addLayout?.layout_data as LayoutData,
        MODE_CONSTANTS.ADD
      )
      const values = data?.formattedValues
      const entity = entitiesByName[addLayout?.entity_name ?? '']

      const flagValue = validatePhoneNumberAndAddress(values, dispatch)
      if (flagValue) {
        return
      }
      if (entity?.is_duplicate) {
        const listingLayout = await fetchListingLayout()
        await fetchTableDataCallback2(values, listingLayout?.id)
      } else {
        handleAddModalData(values)
      }
    } catch (err) {
      console.log(err)
    } finally {
      dispatch(hideLoader())
    }
  }
  const handleOnReload = () => {
    const event = new CustomEvent('custom-search-reload', {
      detail: { timestamp: Date.now() },
    })
    window.dispatchEvent(event)
  }
  useEffect(() => {
    setFetchKey((prev) => prev + 1)
  }, [props?.triggerSearch])

  useEffect(() => {
    if (props?.backToFirstPage) {
      setFetchKey((prev) => prev + 1)
    }
  }, [props?.backToFirstPage])

  useEffect(() => {
    const fetchLayouts = async (): Promise<LayoutResponseType[]> => {
      try {
        dispatch(showLoader())
        const response = await getAllLayoutApi({
          entityId: props.entity_id.toString(),
          defaultValue: true,
        })
        return response.data.content ?? []
      } catch (err) {
        console.error(err)
        return []
      } finally {
        dispatch(hideLoader())
      }
    }
    const fetchRequestorLayout = async () => {
      try {
        const entityViewIds: Record<string, number> = {
          [ENTITY_NAME.PATIENT_ENROLLMENT_VIEW_KEY]: 0,
          [ENTITY_NAME.PROVIDER_VIEW_KEY]: 0,
          [ENTITY_NAME.CASE_VIEW_KEY]: 0,
          [ENTITY_NAME.PHARMACY_VIEW_KEY]: 0,
          [ENTITY_NAME.FACILITIES_VIEW_KEY]: 0,
        }

        const allEntities = Object.values(entitiesByName)
        allEntities.forEach((entity: { name: string; id: number }) => {
          if (entity.name in entityViewIds) {
            entityViewIds[entity.name] = entity.id ?? 0
          }
        })

        const entityMapping: Record<string, keyof typeof entityViewIds> = {
          [NAMESPACES.PATIENT_KEY]: ENTITY_NAME.PATIENT_ENROLLMENT_VIEW_KEY,
          [NAMESPACES.PROVIDER_KEY]: ENTITY_NAME.PROVIDER_VIEW_KEY,
          [ENTITY_NAME.CASE]: ENTITY_NAME.CASE_VIEW_KEY,
          [ENTITY_NAME.FACILITY]: ENTITY_NAME.FACILITIES_VIEW_KEY,
        }
        let response
        const mappedEntity = entityMapping[props.entity_name]
        if (isCallInteractionActive) {
          response = await getLayoutByName({
            entityId: props.entity_id.toString(),
            layoutName: 'Requestor Search Layout',
          })
          setListingLayout(response?.data)
        } else if (mappedEntity) {
          response = await getAllLayoutApi({
            entityId: entityViewIds[mappedEntity]?.toString() ?? '0',
            defaultValue: true,
            type: LAYOUT_TYPE_NAMESPACE.LAYOUT_LISTING,
          })
          setListingLayout(response?.data?.content?.[0])
        } else {
          response = await getLayoutByName({
            entityId: props.entity_id.toString(),
            layoutName: 'Requestor Search Layout',
          })
          setListingLayout(response?.data)
        }
      } catch (err) {
        console.log(err)
      }
    }
    const updateLayouts = async () => {
      allLayouts.current = await fetchLayouts()
      let foundAddLayout = false
      allLayouts.current.forEach((layout) => {
        if (
          layout.type === LAYOUT_TYPE_NAMESPACE.DEFAULT_VIEW_EDIT &&
          layout.default_value
        ) {
          setAddLayout(layout)
          foundAddLayout = true
        }
      })
      fetchRequestorLayout()
      if (!foundAddLayout) setAddLayout(undefined)
    }
    if (props?.isLeftPanel === false) updateLayouts()
    else fetchRequestorLayout()
  }, [props.entity_id])

  return (
    <div>
      <Modal
        isOpen={isExpandModalOpen}
        closeModal={() => setIsExpandModalOpen(false)}
        showCloseButton={false}
        width="w-[80%] h-[90%]"
        closeModalOnOutsideClick={true}
      >
        <div className="flex flex-col gap-3">
          <div className="flex justify-between py-1.5">
            <div className="flex items-center gap-3">
              <span className="text-sm font-medium">
                {NAMESPACES.SEARCH_RESULT}
              </span>
              <span className="font-light text-xs">
                {recordLength}{' '}
                {recordLength === 1 || recordLength === 0
                  ? 'record found'
                  : 'records found'}
              </span>
            </div>
            <span className="flex flex-row items-center gap-2">
              {![
                ENTITY_NAME?.CASE,
                ENTITY_NAME?.FACILITY,
                ENTITY_NAME?.PROVIDER,
              ]?.includes(props.entity_name) ? (
                <CustomButton
                  className="!h-[1.75rem]"
                  customStyles={{ borderColor: '#0A6FCD' }}
                  onClick={() => {
                    props.setAddEntityRecord?.(true)
                    props?.setCurrStep?.((prev) => prev + 1)
                    setIsExpandModalOpen(false)
                  }}
                  tabIndex={props.tabIndex}
                  type="button"
                >
                  Add New {props.entity_name}
                </CustomButton>
              ) : null}
              <button onClick={() => setIsExpandModalOpen(false)} type="button">
                <SvgMinimiseModal />
              </button>
            </span>
          </div>
          <div>
            <ListingTable
              entityId={Number(props.entity_id)}
              entityName={props.entity_name}
              diffKey={CUSTOM_SEPERATOR.ADVANCE_SEARCH_SEPERATOR}
              extraActions={getActions()}
              allLayouts={allLayouts.current}
              layout={listingLayout}
              dataFetchCallback={fetchTableDataCallback}
              refetchKey={fetchKey}
              noDataScreen={SearchNoDataScreen}
              tabIndex={props.tabIndex}
              currStep={props.currStep}
              setCurrStep={props.setCurrStep}
              openInNewTab={!props?.isLeftPanel}
              preventRedirect={props?.isLeftPanel}
              hideFilters
            />
          </div>
        </div>
      </Modal>
      <ConfirmDialog
        open={isLinkModalOpen}
        onCancel={() => setIsLinkModalOpen(false)}
        message={CALL_INTERACTIONS.LINK_INTERACTION_MESSAGE}
        onConfirm={() => onConfirmClick()}
        confirmButtonText={NAMESPACES.CONFIRM}
        cancelButtonText={NAMESPACES.CANCEL_BUTTON}
      ></ConfirmDialog>
      <div className="font-primary flex flex-col gap-3">
        <div>
          <RequesterSearchForm
            isLookupSearch={props?.isLookupSearch}
            currentInteractionTab={props?.currentInteractionTab}
            isLookup={props?.isLookup}
            advancedFiltersData={props?.advancedFiltersData}
            setAdvancedFiltersData={props?.setAdvancedFiltersData}
            backToFirstPage={props?.backToFirstPage}
            entityType={props.entity_name}
            organizationType={props?.organizationType}
            setEntityDataPayload={setEntityDataPayload}
            setRecordFieldsEntityDataPayload={
              props?.setRecordFieldsEntityDataPayload
            }
            setFetchKey={setFetchKey}
            tabIndex={props.tabIndex ?? 0}
            isIncomingCall={props?.isIncomingCall ?? false}
            isOriginInteraction={props.isOriginInteraction}
            triggerSearchButton={props?.triggerSearch}
            fromTask={props?.fromTask ?? false}
          />
        </div>
        {(entityDataPayload || props?.recordFieldsEntityDataPayload) &&
        listingLayout ? (
          <>
            <hr />
            <div className="flex flex-col gap-3">
              <div className="flex justify-between py-1.5">
                <div className="flex items-center gap-3">
                  <span className="text-sm font-medium">
                    {NAMESPACES.SEARCH_RESULT}
                  </span>
                  <span className="font-light text-xs">
                    {recordLength}{' '}
                    {recordLength === 1 || recordLength === 0
                      ? 'record found'
                      : 'records found'}
                  </span>
                </div>

                {props.entity_name !== 'Case' ? (
                  <span className="flex flex-row items-center gap-2">
                    <button onClick={handleOnReload} type="button">
                      <SvgReload />
                    </button>
                    {![
                      ADVANCE_SEARCH_ENTITY_NAMES_MAPPING.PROVIDER?.toLowerCase(),
                      ADVANCE_SEARCH_ENTITY_NAMES_MAPPING.FACILITY?.toLowerCase(),
                    ]?.includes(props?.entity_name?.toLowerCase()) ? (
                      <CustomButton
                        className="!h-[1.75rem]"
                        customStyles={{ borderColor: '#0A6FCD' }}
                        onClick={() => {
                          if (props?.isLeftPanel === false)
                            setOpenAddModal(true)
                          else {
                            props.setAddEntityRecord?.(true)
                            props?.setCurrStep?.((prev) => prev + 1)
                          }
                        }}
                        tabIndex={props.tabIndex}
                        type="button"
                      >
                        Add New {props.entity_name}
                      </CustomButton>
                    ) : null}
                    {props?.isLeftPanel === false ? null : (
                      <button
                        type="button"
                        onClick={() => {
                          setIsExpandModalOpen(true)
                        }}
                      >
                        <SvgExpandModal />
                      </button>
                    )}
                  </span>
                ) : null}
              </div>
              <div>
                <ListingTable
                  entityId={Number(props.entity_id)}
                  diffKey={CUSTOM_SEPERATOR.ADVANCE_SEARCH_SEPERATOR}
                  entityName={props.entity_name}
                  extraActions={getActions()}
                  allLayouts={allLayouts.current}
                  layout={listingLayout}
                  dataFetchCallback={fetchTableDataCallback}
                  refetchKey={fetchKey}
                  noDataScreen={SearchNoDataScreen}
                  tabIndex={props.tabIndex}
                  currStep={props.currStep}
                  setCurrStep={props.setCurrStep}
                  openInNewTab={!props?.isLeftPanel}
                  preventRedirect={props?.isLeftPanel}
                  hideFilters
                />
              </div>
            </div>
          </>
        ) : null}
      </div>
      {openAddModal && addLayout && (
        <Modal
          isOpen={openAddModal}
          closeModal={toggleAddModal}
          showCloseButton={false}
          width="min-w-[75vw] max-w-[80%]"
        >
          {isLoading ? (
            <Loader isGlobal={false} loaderHeight="40" loaderWidth="40" />
          ) : null}
          <div className={`flex flex-col gap-2 ${isLoading ? 'hidden' : ''}`}>
            {!isDuplicateModalOpen && !viewDuplicateRecord ? (
              <FormRenderer
                key={clearAddModalData?.toString()}
                heading={
                  <div className="flex items-center justify-between gap-4 pb-2">
                    <div className="flex items-center gap-3">
                      <div className="cursor-pointer">
                        <SvgLeftArrow
                          onClick={toggleAddModal}
                          className="svg-path-fill-accent-900"
                        />
                      </div>
                      <span className="font-medium text-base font-primary leading-6">
                        {`Add New ${props?.entity_name}`}
                      </span>
                    </div>
                    <div className="flex items-center gap-3">
                      <div className="flex gap-3">
                        <CustomButton
                          onClick={() => {
                            setClearAddModalData((prev) => !prev)
                          }}
                        >
                          <span>{BUTTONS.CLEAR}</span>
                        </CustomButton>
                        <CustomButton isFilled type="submit">
                          <span>{BUTTONS.SAVE}</span>
                        </CustomButton>
                      </div>
                    </div>
                  </div>
                }
                layout={addLayout?.layout_data as LayoutData}
                fullLayout={addLayout as EntityLayout}
                mode={MODE_CONSTANTS?.ADD}
                handleFormSubmit={handleFormSubmit}
              />
            ) : (
              <div>
                <div className="flex justify-between items-center pb-2">
                  <div>
                    <span
                      className="font-medium text-base font-primary leading-6 cursor-pointer"
                      onClick={() => {
                        setViewDuplicateRecord(false)
                        setIsDuplicateModalOpen(false)
                        setSelectedRow(null)
                      }}
                    >
                      {`Add New ${props?.entity_name}`}
                    </span>
                    <span
                      className={`font-medium text-base font-primary cursor-pointer ${
                        !viewDuplicateRecord ? `text-primary-500` : ``
                      }`}
                      onClick={() => {
                        setViewDuplicateRecord(false)
                      }}
                    >
                      {` / ${APPLICATION_PREFERENCES_STRINGS?.DUPLICATE_HEADING}`}
                    </span>
                    {viewDuplicateRecord && (
                      <span className="font-medium text-base font-primary cursor-pointer text-primary-500">
                        {` / ${NAMESPACES.VIEW} ${props?.entity_name}`}
                      </span>
                    )}
                  </div>
                  <div className="flex gap-2">
                    <CustomButton isFilled onClick={createNewRecord}>
                      {APPLICATION_PREFERENCES_STRINGS?.CREATE_ANYWAY}
                    </CustomButton>
                    <CustomButton
                      isFilled
                      onClick={() => {
                        closeAndMoveToAdvancedSearch()
                      }}
                      disabled={isEmpty(selectedRow)}
                    >
                      {APPLICATION_PREFERENCES_STRINGS?.USE_EXISTING}
                    </CustomButton>
                  </div>
                </div>
                {isDuplicateModalOpen &&
                  (!viewDuplicateRecord ? (
                    <div>
                      <span className="font-light text-xs pb-3">
                        {totalRecords}{' '}
                        {totalRecords > 1
                          ? `${APPLICATION_PREFERENCES_STRINGS.RECORD}s`
                          : APPLICATION_PREFERENCES_STRINGS.RECORD}
                        {` ${APPLICATION_PREFERENCES_STRINGS.FOUND}`}
                      </span>
                      <ListingTable
                        entityId={Number(props.entity_id)}
                        entityName={addLayout.entity_name}
                        layout={duplicateListingLayout}
                        hideFilters={true}
                        dataFetchCallback={(payload) =>
                          fetchTableDataCallback2(
                            addedRecord ?? {},
                            duplicateListingLayout?.id ?? 0,
                            payload
                          )
                        }
                        refetchKey={refetchKey}
                        extraColumns={extraColumn}
                        extraActions={extraAction}
                      />
                    </div>
                  ) : (
                    <FormRenderer
                      heading={null}
                      layout={viewLayout?.layout_data as LayoutData}
                      mode={MODE_CONSTANTS?.VIEW}
                      handleFormSubmit={noop}
                      fullLayout={viewLayout as EntityLayout}
                      data={viewRecordData}
                    />
                  ))}
              </div>
            )}
          </div>
        </Modal>
      )}
    </div>
  )
}

export default SearchLayout

export const SelectWorkFlowDropDown: React.FC<
  SelectWorkFlowDropDownPropsType
> = ({
  workflowList = [],
  updateSelectWorkflow,
  disabled,
  isButtonOnTop,
  tabIndex,
  onDropDownClick,
  isPink,
}) => {
  const [popupData, setPopupData] = useState<PositionPropsState | null>(null)
  const dropdownRef = useRef<HTMLDivElement>(null)
  const buttonRef = useRef<HTMLDivElement>(null)
  const [focusedIndex, setFocusedIndex] = useState<number>(-1)
  const [dropdownHeight, setDropdownHeight] = useState<string | undefined>(
    undefined
  )
  const [showTop, setShowTop] = useState(false)

  const itemRefs = useRef<Array<HTMLDivElement | null>>([])
  workflowList.sort((a, b) => {
    if (!a.name) return -1
    if (!b.name) return 1
    return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
  })
  const handleButtonClick = (
    e: React.MouseEvent<HTMLDivElement> | React.KeyboardEvent
  ) => {
    const target = e?.currentTarget as HTMLDivElement
    const buttonRect = target?.getBoundingClientRect()
    const maxDropdownHeight = 328
    const availableSpaceBelow = window.innerHeight - buttonRect.bottom
    const availableSpaceAbove = buttonRect.top

    let showAbove = false
    let computedHeight = maxDropdownHeight
    if (
      availableSpaceBelow < maxDropdownHeight &&
      availableSpaceAbove > availableSpaceBelow
    ) {
      showAbove = true
      computedHeight = Math.min(availableSpaceAbove - 10, maxDropdownHeight)
    } else if (availableSpaceBelow < maxDropdownHeight) {
      computedHeight = Math.min(availableSpaceBelow - 10, maxDropdownHeight)
    }
    setShowTop(showAbove)
    const top =
      (showAbove ? window.innerHeight - buttonRect.y : buttonRect.bottom) +
      window.scrollY

    const popupPosition: PositionPropsState = {
      top,
      right: buttonRect.right - window.scrollX,
      width: buttonRect.width,
    }

    setPopupData({ ...popupPosition })
    setDropdownHeight(`${computedHeight}px`)
    setFocusedIndex(0)
    onDropDownClick && onDropDownClick()
  }

  const clearData = () => {
    setPopupData(null)
    setFocusedIndex(-1)
  }

  const handleSelect = (item: WorkflowDefinitionsListType) => {
    updateSelectWorkflow(item)
    clearData()
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === ShortcutKeys.ArrowDown) {
      e.preventDefault()
      setFocusedIndex((prev) => (prev < workflowList.length - 1 ? prev + 1 : 0))
    } else if (e.key === ShortcutKeys.ArrowUp) {
      e.preventDefault()
      setFocusedIndex((prev) => (prev > 0 ? prev - 1 : workflowList.length - 1))
    } else if (e.key === ShortcutKeys.Enter || e?.key === ShortcutKeys.Space) {
      e.preventDefault()
      if (focusedIndex >= 0) handleSelect(workflowList[focusedIndex])
      else {
        handleButtonClick(e)
      }
    } else if (
      e?.key === ShortcutKeys.Shift ||
      e?.shiftKey ||
      e?.key === ShortcutKeys.Tab
    ) {
      clearData()
      return
    } else {
      e.preventDefault()
      clearData()
    }
  }

  const getChevronColor = (
    isButtonOnTop: boolean | undefined,
    disabled: boolean | undefined
  ): 'primary' | 'error' | 'others' | 'cyan' | 'disabled' => {
    if (!isButtonOnTop) return 'primary'
    if (disabled) return 'disabled'
    return 'cyan'
  }

  const getChevronFillClass = (
    isButtonOnTop: boolean | undefined,
    disabled: boolean | undefined
  ): string => {
    if (!isButtonOnTop) return 'svg-fill-path-primary'
    return disabled ? 'svg-path-fill-accent-900' : 'svg-path-fill-accent-0'
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target as Node)
      ) {
        clearData()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  useEffect(() => {
    const handleScroll = (e: Event) => {
      if (e?.target !== dropdownRef?.current) {
        setPopupData(null)
      }
    }
    if (popupData) {
      window.addEventListener('scroll', handleScroll, true)
    }
    return () => {
      window.removeEventListener('scroll', handleScroll, true)
    }
  }, [popupData])

  useEffect(() => {
    if (focusedIndex >= 0 && itemRefs.current[focusedIndex]) {
      itemRefs.current[focusedIndex]?.scrollIntoView({
        block: 'nearest',
        behavior: 'smooth',
      })
    }
  }, [focusedIndex])
  return (
    <div
      ref={buttonRef}
      className="flex items-stretch relative"
      onClick={isEmpty(popupData) ? handleButtonClick : clearData}
      onKeyDown={handleKeyDown}
      tabIndex={tabIndex ?? 0}
      aria-haspopup="listbox"
      aria-expanded={!!popupData}
      role="button"
    >
      <CustomButton
        type="button"
        color={getChevronColor(isButtonOnTop, disabled)}
        widthClass={`${isButtonOnTop ? 'w-[10.5rem]' : 'w-[8.563rem]'}`}
        className={`border-l-none border-r-2 !h-[1.75rem] ${
          isButtonOnTop ? '!h-[2.37rem]' : ''
        } ${isPink ? 'bg-primary-500 text-white' : ''}`}
        dataQaId="create-new-case"
        disabled={isButtonOnTop ? disabled : false}
        isFilled={isButtonOnTop}
        hcpPrimaryColor={`${
          isButtonOnTop && !isPink ? 'bg-secondary-500' : ''
        } `}
        tabIndex={-1}
      >
        <span className="flex items-center gap-2">
          {isButtonOnTop ? BUTTONS.CREATE_NEW_CASE : REPORTS.CREATE_CASE}
          <SvgChevronUp
            className={`transition-transform duration-300 ${
              popupData ? 'rotate-180' : 'rotate-90'
            } pointer-events-none ${getChevronFillClass(
              isButtonOnTop,
              disabled
            )}`}
          />
        </span>
      </CustomButton>
      {popupData &&
        createPortal(
          <div
            ref={dropdownRef}
            className={`absolute z-[9999]  bg-accent-50 border-l border-r border-b rounded-b flex flex-col overflow-y-auto transition-all duration-300 ${
              popupData
                ? 'scale-y-100 opacity-100'
                : 'scale-y-0 opacity-0 pointer-events-none'
            }`}
            style={{
              ...(!showTop
                ? { top: popupData?.top }
                : { bottom: popupData?.top }),
              right: `calc(100vw - ${popupData.right}px)`,
              minWidth: `${popupData?.width}px`,
              position: 'absolute',
              maxHeight: dropdownHeight,
            }}
          >
            {workflowList?.map((item, index) => (
              <div
                className={`p-3 hover:bg-secondary-100  ${
                  focusedIndex === index
                    ? 'bg-secondary-100 font-semibold'
                    : 'hover:bg-secondary-100'
                }`}
                key={item?.id}
                ref={(el) => (itemRefs.current[index] = el)}
              >
                <span
                  title={item?.name ?? ''}
                  className="truncate block w-full cursor-pointer"
                  onClick={() => handleSelect(item)}
                >
                  {item?.name}
                </span>
              </div>
            ))}
          </div>,
          document.body
        )}
    </div>
  )
}
